const { isEmpty } = require('lodash');

const { prefectures, } = require('../config');

const { entries } = Object;

module.exports = {
  fields: () => {
    return {
      name: {
        label: 'キー名',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
    };
  },
};
